
import GalleryRemove from "../../../assets/filled/GalleryRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryRemoveIcon({ className, dataTestid = "GalleryRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
